export default __webpack_public_path__ + "static/media/landing-vector.01f86ae2.svg";